import styled from 'styled-components';
import { ResultColor } from '../../../../../common/src/rhythm_echo.ts';
import { resultColorCss } from './rhythm_colors.ts';

const entries: Array<{ color: ResultColor; label: string }> = [
  { color: 'green', label: 'on time' },
  { color: 'yellow', label: 'early / late' },
  { color: 'red', label: 'missed' },
];

// The legend under the result rows on the "Rhythm Echo (result)" artboard (issue #3473)
export const RhythmResultLegend = () => (
  <Row>
    {entries.map(({ color, label }) => (
      <Entry key={color} data-color={color}>
        <Square style={{ backgroundColor: resultColorCss[color] }} />
        {label}
      </Entry>
    ))}
  </Row>
);

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
  font-size: 13px;
  line-height: 1.4;
  color: var(--color-text-darker);
`;

const Entry = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

const Square = styled.div`
  flex: none;
  width: 12px;
  height: 12px;
  border-radius: 3px;
`;
